/**
 * Media upload or select input
 */
admin.registerLoad(function (prefix) {
    $(prefix + '.js-media-select').each(function () {
        var container = $(this);

        if (container.data("init")) return;

        container.data("init", 1);

        container.find(".js-media-upload").click(function (ev) {
            ev.preventDefault();

            $('#media-upload').unbind("change");
            $('#media-upload').change(function (ev) {

                container.find(".please_wait").show();

                $('#media-upload-form').submit();
            });

            $('#media-upload-type').val($(this).data('media-type'));

            $('#media-upload-iframe').unbind("load");
            $('#media-upload-iframe').load(function () {
                container.find(".please_wait").hide();

                try {
                    var text = $('#media-upload-iframe').contents().text();
                    if (text.indexOf("{") != 0)
                    {
                        text = text.substr(text.indexOf("{"));
                    }
                    var result = $.parseJSON(text);
                    select_image(result);
                } catch (e)
                {
                    alert(e);
                    return;
                }

            });

            $('#media-upload').click();
        });

        container.find(".js-media-remove").click(function (ev) {

            ev.preventDefault();

            if ($(this).is(":disabled")) return;

            // clear image
            container.find('.js-media-image').attr("src", "");

            // update view link
            container.find('.js-media-view-link').attr('href', "");

            // update download link
            container.find('.js-media-download').attr('href', "");
            container.find(".js-media-download").attr("disabled", "disabled");

            // output new filename
            container.find('.js-media-filename').text("");

            // update form field
            container.find(".js-media-input").val("");

            // enable remove button
            container.find(".js-media-remove").attr("disabled", "disabled");
        });

        container.find('.js-media-choose').click(function (ev) {
            ev.preventDefault();
            $('#media-library-modal').html($('#modal-wait-template').html());
            load_media_library_url($(this).attr('href'));
            $('#media-library-modal').modal();
        });

        function select_image(result) {

            if (result.status != 201) {
                admin.showError(result.errors);
                return;
            }

            // we have a valid media back, lets update our form field and all that other stuff needed

            // update image
            var img = container.find('.js-media-image');
            if (img.length > 0) {
                var width = img.attr('width');
                var height = img.attr('height');
                var fit = img.attr('fit');
                var url = result.urls.image;
                url = url.replace("%WIDTH%", width);
                url = url.replace("%HEIGHT%", height);
                url = url.replace("%FIT%", fit);

                img.attr('src', url);
            }

            // update view link
            container.find('.js-media-view-link').attr('href', result.urls.view);

            // update download link
            container.find('.js-media-download').attr('href', result.urls.download);
            container.find(".js-media-download").removeAttr("disabled");

            // output new filename
            container.find('.js-media-filename').text(result.media.file_name);

            // update form field
            container.find(".js-media-input").val(result.media.id);

            // enable remove button
            container.find(".js-media-remove").removeAttr("disabled");
        }

        function load_media_library_url(url) {
            $('#media-library-modal .modal-content').load(url, function () {
                // once a library is loaded, hook all its links to load in the frame instead of page
                $(this).find("a").click(function (ev) {
                    ev.preventDefault();
                    load_media_library_url($(this).attr('href'));
                });

                $(this).find("select").change(function () {
                    load_media_library_url($(this).val());
                })

                $(this).find('.js-media-image').unbind("click");
                $(this).find('.js-media-image').click(function (ev) {
                    ev.preventDefault();
                    $('#media-library-modal').modal("hide");
                    select_image($(this).data("media"));
                })
            });
        }

        /**
         * From here is stuff for dealing with the MediaStoreLink field type, that
         * works slightly differently as we are editing a media object rather than a reference
         * to a media object
         */

        container.find(".js-media-store-upload").click(function (ev) {
            ev.preventDefault();

            $('#media-upload-form').attr('action', container.data('form-url'));

            $('#media-upload').unbind("change");
            $('#media-upload').change(function (ev) {

                container.find(".please_wait").show();

                $('#media-upload-form').submit();
            });

            $('#media-upload-type').val($(this).data('media-type'));

            $('#media-upload-iframe').unbind("load");
            $('#media-upload-iframe').load(function () {
                container.find(".please_wait").hide();

                try {
                    var text = $('#media-upload-iframe').contents().text();
                    if (text.indexOf("{") != 0)
                    {
                        text = text.substr(text.indexOf("{"));
                    }
                    var result = $.parseJSON(text);
                    select_image_store(result);
                } catch (e)
                {
                    //alert(e);
                    return;
                }

            });

            $('#media-upload').click();
        });

        function select_image_store(result) {

            if (result.status != 201) {
                admin.showError(result.errors);
                return;
            }

            // we have a valid media back, lets update our form field and all that other stuff needed

            // update image
            var img = container.find('.js-media-image');
            if (img.length > 0) {
                var width = img.attr('width');
                var height = img.attr('height');
                var fit = img.attr('fit');
                var url = result.urls.image;
                url = url.replace("%WIDTH%", width);
                url = url.replace("%HEIGHT%", height);
                url = url.replace("%FIT%", fit);

                img.attr('src', url);
            }

            // update view link
            container.find('.js-media-view-link').attr('href', result.urls.view);

            // update download link
            container.find('.js-media-download').attr('href', result.urls.download);
            container.find(".js-media-download").removeAttr("disabled");

            // update form field
            container.find(".js-media-input").val(result.media.identifier);

            // fill out filename, size and extenstion fields
            $('#data-file_name').val(result.media.file_name);
            $('#data-file_size').val(result.media.file_size);
            $('#data-file_ext').val(result.media.file_ext);

            // enable remove button
            container.find(".js-media-remove").removeAttr("disabled");
        }

    });
});
